import { render, staticRenderFns } from "./ValidasiAktivitas-old.vue?vue&type=template&id=bb6fd1fa&lang=html&"
import script from "./ValidasiAktivitas-old.vue?vue&type=script&lang=js&"
export * from "./ValidasiAktivitas-old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports